import { customDiscountLabel, invoiceTotalsAmountRows, } from '@packages/types';
import { grossSubtotalLabel } from './discount-subtotal.js';
export function invoiceTotalsRows(input) {
    const { lineItems, totals, copy, vatLabel, documentType = 'invoice' } = input;
    const customDiscount = customDiscountLabel(lineItems, copy('invoice:totals.discount'));
    const discountLabel = customDiscount ?? copy('invoice:totals.discount');
    const labels = {
        grossSubtotal: grossSubtotalLabel(copy, customDiscount),
        discount: discountLabel,
        subtotalExcludingVat: copy('invoice:totals.subtotalExcludingVat'),
        vat: vatLabel,
        feesSubtotal: copy('invoice:pdf.feesSubtotal'),
        feesAfterDiscount: copy(customDiscount ? 'invoice:totals.feesAfterAdjustment' : 'invoice:totals.feesAfterDiscount'),
        feesVat: copy('invoice:totals.feesVat'),
        disbursementsSubtotal: copy('invoice:pdf.disbursementsSubtotal'),
        disbursementsDiscount: discountLabel,
        disbursementsAfterDiscount: copy(customDiscount ? 'invoice:totals.disbursementsAfterAdjustment' : 'invoice:totals.disbursementsAfterDiscount'),
        disbursementsVat: copy('invoice:totals.disbursementsVat'),
        total: copy('invoice:totals.total'),
    };
    return invoiceTotalsAmountRows({ lineItems, totals, documentType }).map((row) => ({ ...row, label: labels[row.key] }));
}
